import React, { useState, useEffect } from 'react';

const Group = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showPdf, setShowPdf] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);

  const groupPackages = [
    {
      name: "Casual Gathering",
      price: 35,
      perPerson: true,
      minPeople: 10,
      description: "Perfect for casual team lunches and small celebrations",
      includes: [
        "Choice of 2 appetizers",
        "Choice of 3 main courses",
        "Soft drinks included",
        "Dessert platter"
      ]
    },
    {
      name: "Corporate Package",
      price: 45,
      perPerson: true,
      minPeople: 20,
      description: "Ideal for business meetings and corporate events",
      includes: [
        "Premium appetizer platter",
        "Choice of 4 main courses",
        "Wine and beer included",
        "Dessert selection",
        "Coffee and tea service"
      ]
    },
    {
      name: "Special Celebration",
      price: 55,
      perPerson: true,
      minPeople: 30,
      description: "Perfect for weddings and special occasions",
      includes: [
        "Deluxe appetizer selection",
        "Choice of 5 main courses",
        "Premium beverage package",
        "Custom dessert station",
        "Late night snack station"
      ]
    }
  ];

  return (
    <div className={`${isVisible ? 'page-transition-active' : 'page-transition'}`}>
      <div className="min-h-screen bg-[#EFEAE7] flex items-center">
        <div className="container mx-auto px-4 md:px-16 max-w-7xl py-12">
          <h1 className="font-['Playfair_Display_SC'] text-4xl md:text-5xl font-bold mb-20 text-[#2E492A] text-center">
            Function Packages
          </h1>

          {/* Group Packages */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* First Package */}
            <div className="bg-white rounded-md p-6 text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-2">
              <h3 className="font-['Outfit'] text-2xl font-bold mb-2 text-[#2E492A]">
                {groupPackages[0].name}
              </h3>
              <p className="text-gray-600 mb-4">{groupPackages[0].description}</p>
              <div className="mb-4">
                <p className="font-bold text-xl mb-2 text-[#2E492A]">
                  ${groupPackages[0].price} per person
                </p>
                <p className="text-sm text-gray-500">
                  Minimum {groupPackages[0].minPeople} people
                </p>
              </div>
              <div>
                <h4 className="font-bold mb-2 text-[#2E492A]">Includes:</h4>
                <ul className="space-y-1">
                  {groupPackages[0].includes.map((item, i) => (
                    <li key={i} className="text-gray-600 text-sm">
                      • {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Middle Package (Taller) */}
            <div className="bg-white rounded-md p-6 md:-mt-8 md:mb-8 text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-2 relative before:absolute before:inset-0 before:border-2 before:border-[#2E492A] before:rounded-md before:opacity-0 hover:before:opacity-100 before:transition-all before:duration-300">
              <h3 className="font-['Outfit'] text-2xl font-bold mb-2 text-[#2E492A]">
                {groupPackages[1].name}
              </h3>
              <p className="text-gray-600 mb-4">{groupPackages[1].description}</p>
              <div className="mb-4">
                <p className="font-bold text-xl mb-2 text-[#2E492A]">
                  ${groupPackages[1].price} per person
                </p>
                <p className="text-gray-500">
                  Minimum {groupPackages[1].minPeople} people
                </p>
              </div>
              <div>
                <h4 className="font-bold mb-2 text-[#2E492A]">Includes:</h4>
                <ul className="space-y-1">
                  {groupPackages[1].includes.map((item, i) => (
                    <li key={i} className="text-gray-600">
                      • {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Last Package */}
            <div className="bg-white rounded-md p-6 text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-2">
              <h3 className="font-['Outfit'] text-2xl font-bold mb-2 text-[#2E492A]">
                {groupPackages[2].name}
              </h3>
              <p className="text-gray-600 mb-4">{groupPackages[2].description}</p>
              <div className="mb-4">
                <p className="font-bold text-xl mb-2 text-[#2E492A]">
                  ${groupPackages[2].price} per person
                </p>
                <p className="text-sm text-gray-500">
                  Minimum {groupPackages[2].minPeople} people
                </p>
              </div>
              <div>
                <h4 className="font-bold mb-2 text-[#2E492A]">Includes:</h4>
                <ul className="space-y-1">
                  {groupPackages[2].includes.map((item, i) => (
                    <li key={i} className="text-gray-600 text-sm">
                      • {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* View Packages Button */}
          <div className="text-center flex flex-col items-center gap-8">
            <button 
              onClick={() => setShowPdf(!showPdf)}
              className="inline-block px-8 py-3 bg-[#2E492A] text-white rounded-full font-['Outfit'] hover:bg-[#2E492A]/80 transition-colors button-hover"
            >
              View Our Function Packages
            </button>

            {/* Menu Image Section */}
            {showPdf && (
              <div className="w-full max-w-4xl transition-all duration-500 ease-out transform opacity-100 scale-100 animate-fadeIn">
                <img
                  src="/packages.png"
                  alt="Function Packages Menu"
                  className="w-full h-auto rounded-lg shadow-lg"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Group; 